<template>
    <va-edit-layout>
        <ShipmentEventShipmentFee-form
            :id="id"
            :title="title"
            :item="item"
        ></ShipmentEventShipmentFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
